import { Component } from 'react';
import { connect } from 'react-redux';

import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { translate } from 'utils/translate';

interface HelpVideosModelModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;

    //unused props
    data: any;
    actions: ActionsType | undefined;
}

interface HelpVideosModelModelState {
    //unused state
    errors: object;

    //unused state
    data: any | null;

    links: {
        title: string;
        dissection: string;
        link: string;
    }[];
}

class HelpVideosModelModel extends Component<HelpVideosModelModelProps, HelpVideosModelModelState> {
    constructor(props: HelpVideosModelModelProps) {
        super(props);
        this.state = {
            data: null,
            errors: {},
            links: [
                {
                    title: 'Login and security',
                    dissection:
                        'How to log in, logout, manage your browser, and get assistance with login or password problems.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUu8SuSE_hIeFYdHuFeo_Q0J',
                },
                {
                    title: 'Overview of the system',
                    dissection:
                        'Learn the main features of TransitAnalyst, it’s core capabilities and most important concepts.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUv3FU5qEGy8I3arT7anVfpQ',
                },
                {
                    title: 'Searching for transits',
                    dissection:
                        'Finding the transits that are of interest to you, searching with efficiency, and tuning the search results.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUspLVPRtYyPABxoLSmMIQ_3',
                },
                {
                    title: 'Interacting with transits',
                    dissection:
                        'Understanding the central actions that can be performed against an individual transit or collection of transits.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUvrYMH1tW2XetukulAFfMum',
                },
                {
                    title: 'Customising the system',
                    dissection:
                        'Changing the way TransitAnalyst displays, analyses and manages transits to meet your specific needs.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUtlUqwLyQKIutS7ni0XzQ5t',
                },
                {
                    title: 'System administration',
                    dissection:
                        'Performing administrative tasks that keep your TransitAnalyst system tuned and healthy.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUvVNu2UjH_lOBOOTm4O14Yr',
                },
                {
                    title: 'How to videos',
                    dissection: 'See how TransitAnalyst is used to support common workflows in pilotage operations.',
                    link: 'https://www.youtube.com/playlist?list=PLp41iwofxKUsysFyYneM8DDX1CG4ZdEMI',
                },
            ],
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form
                    onSubmit={this.handleFormSubmit}
                    className="bg-white shadow p-4 w-full rounded"
                    style={{ width: '700px' }}
                >
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('TransitAnalyst Videos')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                        {this.state.links.map((link, index) => {
                            return (
                                <div key={index}>
                                    <div className="flex items-center gap-1 mb-2">
                                        <div>
                                            <Icon className="h-5 w-5">
                                                <path d="M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z" />
                                                <path d="M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z" />
                                            </Icon>
                                        </div>
                                        <a
                                            href={link.link}
                                            target="_blank"
                                            className="text-blue-500  text-bold"
                                            rel="noreferrer"
                                        >
                                            {link.title}
                                        </a>
                                    </div>
                                    <div className="text-gray-400">{link.dissection}</div>
                                </div>
                            );
                        })}
                    </div>
                    {/* <div className="flex justify-end">
                        <div className="mt-5">
                            <Button  className="px-4 py-1 font-bold border border-gray-200" onClick={this.handleFormCancel}>
                                {translate('Cancel')}
                            </Button>
                        </div>
                    </div> */}
                </Form>
            </>
        );
    }
}

const helpVideosModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

const helpVideosModelDispatchToProps = () => ({});

export default connect(helpVideosModelStateToProps, helpVideosModelDispatchToProps)(HelpVideosModelModel);
